import './forbidden.scss';

export default function Forbidden() {
    return (
        <div className="forbidden-container">
            <h1 className="forbidden-title">We can't share this with you.</h1>
            <div className="forbidden-error-message" data-testid="forbidden-error-message">
                It looks like you don't have access to the page or resource you're trying to reach. Try refreshing the
                page first. If you need additional help, ask an authorized contact to submit a work order to Paycor.
            </div>
        </div>
    );
}
